import { InjectionToken } from '@angular/core';

export type FormErrorMap = Record<string, (error: unknown) => string>;

export const defaultErrors: FormErrorMap = {
  required: () => 'errors.required',
};

export const FORM_ERRORS = new InjectionToken<FormErrorMap>('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => defaultErrors,
});
